<template>
  <v-menu
    :max-width="'480px'"
    :nudge-bottom="10"
    :nudge-right="70"
    :close-on-content-click="false"
    content-class="shadow-lg"
    offset-y
    on
    bottom
    left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mx-1" icon v-bind="attrs" v-on="on">
        <v-badge
          :content="notifications.length"
          :value="notifications.length"
          color="warning lighten-1"
          overlap
        >
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card width="480" class="rounded-lg">
      <v-card-title class="pb-0 font-weight-regular text-subtitle-1">
        Notifications 
        <v-spacer></v-spacer>
        <v-btn 
          v-if="notifications.length > 1"
          text
          color="primary"
          class="text-caption font-weight-semibold text-capitalize"
          small
          @click="clearAllNotifications()"
        >
          Clear All
        </v-btn>
      </v-card-title>
      <v-divider class="mt-3" />
      <v-card-text class="pt-0" style="height: 640px; overflow-y: auto">

        <v-list two-line>
          <v-list-item-group active-class="">

            <template v-for="(item, index) in internalNotifications">
              <v-list-item :key="item._id" :to="{ name:  `${item?.route || ''}` }">

                <template v-slot:default="{ active }">
                  
                  <v-list-item-avatar>
                    <v-avatar
                      size="70"
                      class="grey lighten-3 text-center align-self-center"
                    >
                      <v-img :src="imgUrls[item.senderID]"></v-img>
                      <!-- <v-icon v-else size="25">mdi-account-outline</v-icon> -->
                    </v-avatar>
                  </v-list-item-avatar>


                  <v-list-item-content class="mr-4">
                    <v-list-item-title class="d-flex">
                      <!-- <template v-if="!item.isRead" >
                        <div class="ping-container mr-4 ml-1 mt-1">
                          <v-icon
                            class="ping-circle ping-animation"
                            color="primary lighten-1"
                            size="10"
                          >
                            mdi-circle
                          </v-icon>
                        </div>
                      </template> -->
                      
                      <div class="ml-6 mb-1 text-caption">
                        {{ item.title }}
                      </div>

                      <v-spacer/>

                      <div
                        class="grey--text text--darken-1"
                        style="font-weight: 400; font-size: 0.67rem;"
                        v-text="convertToFromNow(item.dateCreated)"
                      ></div>
                    </v-list-item-title>

                    <v-list-item-subtitle
                      class="ml-7 mb-1 text-wrap text-caption"
                    >
                      {{ item.message }}
                    </v-list-item-subtitle>

                    <v-list-item-subtitle>
                      <!-- <v-btn 
                        class="ml-4" 
                        small
                        depressed
                        color="primary"
                        text
                        @click="markAsRead({ notification: item, id: item.id })"
                      >
                        View
                      </v-btn> -->
                      <v-btn
                        class="ml-4 text-capitalize"
                        small
                        depressed
                        color="primary"
                        text
                        @click="clearNotification(item.id)"
                      >
                        Clear
                      </v-btn>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>

              <v-divider
                v-if="index < notifications.length - 1"
                :key="index"
              ></v-divider>
            </template>

          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import moment  from 'moment';
import { mapActions, mapGetters } from 'vuex';
moment.updateLocale('en-short', {
  relativeTime: {
    past: "%s ago",
    s: 'a few seconds',
    m: '1 min',
    mm: '%d mins',
    h: '1 hr',
    hh: '%d hrs',
  }
});

const notificationRouteMap = {
  'case unassignment': 'my-assigned-cases',
  'case assignment': 'my-assigned-cases',
  'foreclosure assignment': 'my-foreclosure-loans',
  'foreclosure unassignment': 'my-foreclosure-loans',
  'charge-off assignment': 'my-charge-off-cases',
  'charge-off unassignment': 'my-charge-off-cases'
}

export default {
  name: 'NotificationMenu',
  props: {
    notifications: {
      type: [],
      default: () => []
    }
  },

  data() {
    return {
      imgUrls: {},
    }
  },

  mounted() { 
    this.prefetch();
  },

  computed: {
    ...mapGetters('authModule', ['user']),

    
    internalNotifications() {
      return this.notifications.map( notification => {
        notification.route = notificationRouteMap[notification.type] || ''
        return notification
      })
    },
  },

  methods: {
    ...mapActions('userNotificationsModule', ['markAsRead', 'deleteNotification', 'deleteNotifications']),
    ...mapActions('userModule', ['findAvatar']),
    
    async prefetch() {
      for (const { senderID } of this.notifications) {
        if (this.imgUrls[senderID]) continue;

        const imgUrl = await this.findAvatar(senderID);
        this.$set(this.imgUrls, senderID, imgUrl);
      }
    },

    convertToFromNow(date) {
      moment.locale('en-short');
      return moment(date).fromNow()
    },

    clearNotification(id) {
      this.deleteNotifications({ userId: this.user.id, ids: [id] });
    },

    clearAllNotifications() {
      this.deleteNotifications({ userId: this.user.id, ids: this.notifications.map( n => n.id) })
    }
  },

  watch: {
    notifications: {
      deep: true,
      handler() {
        this.prefetch();
      }
    }
  }
};
</script>
<style lang="css" scoped>
  .v-list-item {
    align-items: flex-start;
  }

  .v-list-item__action {
    align-self: start;
  }

  .ping-container {
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #488fef ; /* Example base color */
  }

  .ping-circle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5); /* Ping color */
  }

  .ping-animation {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

  @keyframes ping {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    75%, 100% {
      transform: scale(2); /* Adjust scale for desired effect */
      opacity: 0;
    }
  }

  .v-list-item--link:before {
    background-color: transparent;
  }
</style>
